import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MonitoringService } from 'src/app/services/monitoring.service';

@Injectable(
  {providedIn: 'root'}
)
export class GlobalErrorHandlerService implements ErrorHandler {

  public constructor(private injector: Injector){}

  monitoringService: MonitoringService;

  public handleError(error: any) {

    this.monitoringService = this.injector.get(MonitoringService);
    this.monitoringService.logError(error);

    if (error instanceof HttpErrorResponse) {
        //Backend returns unsuccessful response codes such as 404, 500 etc.
        console.error('Backend returned status code: ', error.status);
        console.error('Response body:', error.message);
    } else {
        //A client-side or network error occurred.
        console.error('An error occurred:', error.message);
    }
  }
}
